import { render, staticRenderFns } from "./AnaliticsList.vue?vue&type=template&id=04966fa7"
import script from "./AnaliticsList.vue?vue&type=script&lang=js"
export * from "./AnaliticsList.vue?vue&type=script&lang=js"
import style0 from "./AnaliticsList.vue?vue&type=style&index=0&id=04966fa7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports